import ApiService from '@/api';
import { GetProjectTasksRequestModel } from '../models';
import { PaginationResponseModel, ProjectModel, UserModel } from '@/models';
import { ResponseModel } from 'tir-pm-file-upload-manager';
import { TaskModel } from '../models/TaskModel';
import {
  mapGetEmployeeRequest,
  mapGetEmployeeResponse,
  mapGetProjectRequest,
  mapGetProjectResponse,
  mapGetTasksByProjectIdRequest,
  mapGetTasksByProjectIdResponse,
} from './AdapterServieMappers';

export class AdapterService {
  /**Сервис для использования api */
  private readonly api = new ApiService();

  /**
   * Получить список задач по проекту
   * @param request Запрос
   * @returns
   */
  getTasksByProjectId(
    request: GetProjectTasksRequestModel,
  ): Promise<PaginationResponseModel<TaskModel[]>> {
    return new Promise<PaginationResponseModel<TaskModel[]>>(async (resolve) => {
      let result = new PaginationResponseModel<TaskModel[]>();

      await this.api.Main.ProjectTaskGetService.getTaskListByTreeShortAsync(
        mapGetTasksByProjectIdRequest(request),
      )
        .then((resp) => {
          result = mapGetTasksByProjectIdResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTasksByProjectId', e);
          return resolve(result);
        });
    });
  }
  /**
   * Получить информацию о сотруднике
   * @param employeeId ID сотрудника
   * @returns
   */
  getEmployee(employeeId: number) {
    return new Promise<ResponseModel<UserModel>>(async (resolve) => {
      const result = new ResponseModel<UserModel>();

      await this.api.Main.PerformersListService.getByIdAsync(mapGetEmployeeRequest(employeeId))
        .then((resp) => {
          result.Value = mapGetEmployeeResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getEmployee', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получить проект
   * @param projectId ID проекта
   * @returns
   */
  getProject(projectId: number) {
    return new Promise<ResponseModel<ProjectModel>>(async (resolve) => {
      const result = new ResponseModel<ProjectModel>();

      await this.api.Main.ProjectBaseService.getIdAsync(mapGetProjectRequest(projectId))
        .then((resp) => {
          result.Value = mapGetProjectResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getProject', e);
          return resolve(result);
        });
    });
  }
}
